import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pipeline-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css'],
})
export class PipelineStatusComponent implements OnInit {
  @Input('status') status: string;

  constructor() {}

  ngOnInit(): void {}
}
